/**
 * @internal
 */
export function formatFileSystemTree(tree) {
    const newTree = { d: {} };
    for (const name of Object.keys(tree)) {
        const entry = tree[name];
        if ('file' in entry) {
            const contents = entry.file.contents;
            const stringContents = typeof contents === 'string' ? contents : binaryString(contents);
            const binary = typeof contents === 'string' ? {} : { b: true };
            newTree.d[name] = { f: { c: stringContents, ...binary } };
            continue;
        }
        const newEntry = formatFileSystemTree(entry.directory);
        newTree.d[name] = newEntry;
    }
    return newTree;
}
function binaryString(bytes) {
    let result = '';
    for (const byte of bytes) {
        result += String.fromCharCode(byte);
    }
    return result;
}
